import { onCLS } from 'web-vitals';
import getNodeCSSPath from '../utils/get-node-css-path';

/**
 * Get the largest shifted node from the top three layout shifts. The node, along with the
 * associated CLS score for the layout shift, will be sent in the analytics event. The logic was
 * mostly taken from here:
 * @see
 * https://web.dev/debug-web-vitals-in-the-field/#get-layout-shift-attribution
 */
const largestLayoutShiftNode = (trackPerformanceMetricEvent) => {
  onCLS(({ entries }) => {
    if (!entries.length) {
      return;
    }

    /**
     * @TODO
     * Wrapping some of the functionality in a try catch as tests are yet to be written. Revisit
     * tests once we explore the usefulness of this metric and settle on a final approach.
     */
    try {
      const layout_shifts = [...entries];

      // Sort all layout shifts from largest descending
      layout_shifts.sort((a, b) => a && a.value > b.value ? -1 : 1);

      // Only report on the top three largest layout shifts.
      layout_shifts.slice(0, 3).forEach((layout_shift, index) => {
        if (layout_shift && layout_shift.sources && layout_shift.sources.length) {

          // determine the largest shifted node
          const largest_source = layout_shift.sources.reduce((a, b) => {
            if (!a.node) {
              return false;
            }

            const a_score = a.previousRect.width * a.previousRect.height;
            const b_score = b.previousRect.width * b.previousRect.height;

            return a_score > b_score ? a : b;
          });

          trackPerformanceMetricEvent({
            metric_name: `largest-layout-shift-node-${index}`,
            metric_type: 'custom',
            metric_value: layout_shift.value,
            metric_metadata_type: 'css-selector',
            metric_metadata_value: getNodeCSSPath(largest_source.node) || '',
          });
        }
      });
    } catch(error) {}
  });
};

export default largestLayoutShiftNode;
